<script setup lang="ts">
import { usePage } from "@inertiajs/vue3"
import { Check, GitCommitHorizontal } from "lucide-vue-next"
import { computed } from "vue"

import { useCopyToClipboard } from "@/composables/useCopyToClipboard"

const page = usePage()
const { copy, isCopied } = useCopyToClipboard()

const shortVersion = computed(() => page.props.app_version.slice(0, 7))
const copyVersion = () => copy(page.props.app_version, "app_version")
</script>

<template>
  <button
    type="button"
    :title="`Copy commit SHA: ${page.props.app_version}`"
    class="text-sidebar-foreground/60 bg-sidebar-accent hover:bg-sidebar-accent hover:text-sidebar-foreground group-data-[collapsible=icon]:hidden mx-2 mt-1 inline-flex w-fit items-center gap-1 rounded-full px-2 py-0.5 text-[10px] font-medium transition-colors"
    @click="copyVersion"
  >
    <Check v-if="isCopied('app_version')" class="size-2.5" />
    <GitCommitHorizontal v-else class="size-2.5" />
    <span v-if="isCopied('app_version')">Copied!</span>
    <span v-else>v{{ shortVersion }}<template v-if="page.props.app_build_time"> · {{ page.props.app_build_time }}</template></span>
  </button>
</template>
